module.exports = __webpack_public_path__ + "img/10.e0af7fbc.jpg";